import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router'

import * as ROUTES from 'config/routes'
import SiteEdit from './site-edit'
import SiteList from './site-list'
import SiteAdd from './site-add'
import { PageContent } from 'components'
import { PageContainer } from 'smart-components'
import { userIsAuthenticatedRedir } from 'hocs/auth'

const Site = () => (
    <PageContainer>
        <PageContent>
            <PageContent.Main>
                <Switch>
                    <Route
                        exact
                        path={ROUTES.SITE}
                        component={SiteList}
                    />
                    <Route
                        exact
                        path={ROUTES.SITE_EDIT}
                        component={SiteEdit}
                    />
                    <Route
                        exact
                        path={ROUTES.SITE_ADD}
                        component={SiteAdd}
                    />
                </Switch>
            </PageContent.Main>
        </PageContent>
    </PageContainer>
)

export default userIsAuthenticatedRedir(Site)



// WEBPACK FOOTER //
// ./src/pages/site/index.js